// @ts-check
import React from 'react';
import IconsContainer from 'Utils/IconsContainer';
import 'Styles/commonComponents/modalWindow.scss'
import { observer } from 'mobx-react';
import AppStore from 'Stores/AppStore';

/**
 * @typedef {Object} ModalWindowButtonsProps
 * @property {(arg0: () => void) => void} [onClick]
 * @property {boolean} closer
 * @property {string} className
 * @property {React.JSX.Element | string} content
 */

/**
 * @typedef {Object} ModalWindowProps
 * @property {boolean} canBeClosed
 * @property {() => void} close
 * @property {()=>void} onCloseClick
 * @property {React.JSX.Element | string} header,
 * @property {() => React.JSX.Element | string} getHeader
 * @property {React.JSX.Element | string} children
 * @property {()=> React.JSX.Element | string} getChildren
 * @property {boolean} classNameMainWithBackground
 * @property {string} className
 * @property {import('react').CSSProperties | undefined} bodyStyle
 * @property {ModalWindowButtonsProps[]} buttons
 * @property {() => ModalWindowButtonsProps[]} getButtons
 * @property {import('csstype').Property.JustifyContent | undefined} buttonsStyleJustifyContent
 * @property {import('csstype').Property.Width<string | number> | undefined} width
 * @property {import('csstype').Property.Width<string | number> | undefined} height
 * @property {boolean} blockProductSwitcher
 */

/**
 * @param {ModalWindowProps} props 
 * @returns 
 */
const ModalWindow = (props) => {
    let { canBeClosed, close, onCloseClick, header, getHeader, children, getChildren, classNameMainWithBackground, className, bodyStyle: bodyStyle,
        buttons, getButtons, buttonsStyleJustifyContent, width, height, maxWidth, blockProductSwitcher } = props;

    if (classNameMainWithBackground !== false) {
        classNameMainWithBackground = true;
    }

    /** @type {React.JSX.Element[]} */
    let renderedButtons = [];

    if (getButtons) {
        buttons = getButtons();
    }

    if (buttons) {
        renderedButtons = buttons.map((button, index) => {
            let clicker = () => {
                if (button.onClick)
                    button.onClick(close); //передаем на случай, если закрыть модалку нужно после какого-то действия

                if (button.closer)
                    close();
            };

            return (
                <button onClick={clicker}
                    key={index}
                    className={button.className ? button.className : ''}>
                    {button.content}
                </button>
            )
        });
    }

    return (
        <div className={`modal-window ${classNameMainWithBackground ? 'modal-window-background-color' : ''} ${(className == null ? '' : className)}`}>
            <div className='modal-window-visual-block' style={{ width: width, height: height, maxWidth: maxWidth }}>
                <div className='modal-window-header'>
                    <div className={`modal-window-header-text ${canBeClosed ? "" : "modal-window-header-text-without-close-button"}`}>
                        {getHeader ? getHeader() : header}
                    </div>
                    {canBeClosed ? (
                        <div className="close-modal-button"
                            onClick={_ => {
                                if (onCloseClick != null)
                                    onCloseClick();
                                close();
                            }}>
                            {IconsContainer.Get('ci-cross')}
                        </div>
                    ) : null}
                </div>
                <div
                    className='modal-window-body overflowing-element'
                    style={bodyStyle}>
                    {getChildren ? getChildren() : children}
                </div>
                <div
                    className={renderedButtons.length > 0 ? "modal-window-button-container" : "modal-window-empty-button-container"}
                    style={{ justifyContent: buttonsStyleJustifyContent }}>
                    {renderedButtons}
                </div>
            </div>
        </div>
    )
};

export default observer(ModalWindow);